[
  { "id": 4, "code": "af", "text": "Afghanistan" },
  { "id": 248, "code": "ax", "text": "Åland Islands" },
  { "id": 8, "code": "al", "text": "Albania" },
  { "id": 12, "code": "dz", "text": "Algeria" },
  { "id": 16, "code": "as", "text": "American Samoa" },
  { "id": 20, "code": "ad", "text": "Andorra" },
  { "id": 24, "code": "ao", "text": "Angola" },
  { "id": 660, "code": "ai", "text": "Anguilla" },
  { "id": 10, "code": "aq", "text": "Antarctica" },
  { "id": 28, "code": "ag", "text": "Antigua and Barbuda" },
  { "id": 32, "code": "ar", "text": "Argentina" },
  { "id": 51, "code": "am", "text": "Armenia" },
  { "id": 533, "code": "aw", "text": "Aruba" },
  { "id": 36, "code": "au", "text": "Australia" },
  { "id": 40, "code": "at", "text": "Austria" },
  { "id": 31, "code": "az", "text": "Azerbaijan" },
  { "id": 44, "code": "bs", "text": "Bahamas" },
  { "id": 48, "code": "bh", "text": "Bahrain" },
  { "id": 50, "code": "bd", "text": "Bangladesh" },
  { "id": 52, "code": "bb", "text": "Barbados" },
  { "id": 112, "code": "by", "text": "Belarus" },
  { "id": 56, "code": "be", "text": "Belgium" },
  { "id": 84, "code": "bz", "text": "Belize" },
  { "id": 204, "code": "bj", "text": "Benin" },
  { "id": 60, "code": "bm", "text": "Bermuda" },
  { "id": 64, "code": "bt", "text": "Bhutan" },
  { "id": 68, "code": "bo", "text": "Bolivia" },
  { "id": 535, "code": "bq", "text": "Bonaire, Sint Eustatius and Saba" },
  { "id": 70, "code": "ba", "text": "Bosnia and Herzegovina" },
  { "id": 72, "code": "bw", "text": "Botswana" },
  { "id": 74, "code": "bv", "text": "Bouvet Island" },
  { "id": 76, "code": "br", "text": "Brazil" },
  { "id": 86, "code": "io", "text": "British Indian Ocean Territory" },
  { "id": 96, "code": "bn", "text": "Brunei Darussalam" },
  { "id": 100, "code": "bg", "text": "Bulgaria" },
  { "id": 854, "code": "bf", "text": "Burkina Faso" },
  { "id": 108, "code": "bi", "text": "Burundi" },
  { "id": 132, "code": "cv", "text": "Cabo Verde" },
  { "id": 116, "code": "kh", "text": "Cambodia" },
  { "id": 120, "code": "cm", "text": "Cameroon" },
  { "id": 124, "code": "ca", "text": "Canada" },
  { "id": 136, "code": "ky", "text": "Cayman Islands" },
  { "id": 140, "code": "cf", "text": "Central African Republic" },
  { "id": 148, "code": "td", "text": "Chad" },
  { "id": 152, "code": "cl", "text": "Chile" },
  { "id": 156, "code": "cn", "text": "China" },
  { "id": 162, "code": "cx", "text": "Christmas Island" },
  { "id": 166, "code": "cc", "text": "Cocos (Keeling) Islands" },
  { "id": 170, "code": "co", "text": "Colombia" },
  { "id": 174, "code": "km", "text": "Comoros" },
  { "id": 178, "code": "cg", "text": "Congo" },
  { "id": 180, "code": "cd", "text": "Congo, the Democratic Republic of the" },
  { "id": 184, "code": "ck", "text": "Cook Islands" },
  { "id": 188, "code": "cr", "text": "Costa Rica" },
  { "id": 384, "code": "ci", "text": "Côte d'Ivoire" },
  { "id": 191, "code": "hr", "text": "Croatia" },
  { "id": 192, "code": "cu", "text": "Cuba" },
  { "id": 531, "code": "cw", "text": "Curaçao" },
  { "id": 196, "code": "cy", "text": "Cyprus" },
  { "id": 203, "code": "cz", "text": "Czech Republic", "altNames": ["Czechia"] },
  { "id": 208, "code": "dk", "text": "Denmark" },
  { "id": 262, "code": "dj", "text": "Djibouti" },
  { "id": 212, "code": "dm", "text": "Dominica" },
  { "id": 214, "code": "do", "text": "Dominican Republic" },
  { "id": 218, "code": "ec", "text": "Ecuador" },
  { "id": 818, "code": "eg", "text": "Egypt" },
  { "id": 222, "code": "sv", "text": "El Salvador" },
  { "id": 226, "code": "gq", "text": "Equatorial Guinea" },
  { "id": 232, "code": "er", "text": "Eritrea" },
  { "id": 233, "code": "ee", "text": "Estonia" },
  { "id": 231, "code": "et", "text": "Ethiopia" },
  { "id": 238, "code": "fk", "text": "Falkland Islands (Malvinas)" },
  { "id": 234, "code": "fo", "text": "Faroe Islands" },
  { "id": 242, "code": "fj", "text": "Fiji" },
  { "id": 246, "code": "fi", "text": "Finland" },
  { "id": 250, "code": "fr", "text": "France" },
  { "id": 254, "code": "gf", "text": "French Guiana" },
  { "id": 258, "code": "pf", "text": "French Polynesia" },
  { "id": 260, "code": "tf", "text": "French Southern Territories" },
  { "id": 266, "code": "ga", "text": "Gabon" },
  { "id": 270, "code": "gm", "text": "Gambia" },
  { "id": 268, "code": "ge", "text": "Georgia" },
  { "id": 276, "code": "de", "text": "Germany" },
  { "id": 288, "code": "gh", "text": "Ghana" },
  { "id": 292, "code": "gi", "text": "Gibraltar" },
  { "id": 300, "code": "gr", "text": "Greece" },
  { "id": 304, "code": "gl", "text": "Greenland" },
  { "id": 308, "code": "gd", "text": "Grenada" },
  { "id": 312, "code": "gp", "text": "Guadeloupe" },
  { "id": 316, "code": "gu", "text": "Guam" },
  { "id": 320, "code": "gt", "text": "Guatemala" },
  { "id": 831, "code": "gg", "text": "Guernsey" },
  { "id": 324, "code": "gn", "text": "Guinea" },
  { "id": 624, "code": "gw", "text": "Guinea-Bissau" },
  { "id": 328, "code": "gy", "text": "Guyana" },
  { "id": 332, "code": "ht", "text": "Haiti" },
  { "id": 334, "code": "hm", "text": "Heard Island and McDonald Islands" },
  { "id": 336, "code": "va", "text": "Holy See (Vatican City State)" },
  { "id": 340, "code": "hn", "text": "Honduras" },
  { "id": 344, "code": "hk", "text": "Hong Kong" },
  { "id": 348, "code": "hu", "text": "Hungary" },
  { "id": 352, "code": "is", "text": "Iceland" },
  { "id": 356, "code": "in", "text": "India" },
  { "id": 360, "code": "id", "text": "Indonesia" },
  { "id": 364, "code": "ir", "text": "Iran" },
  { "id": 368, "code": "iq", "text": "Iraq" },
  { "id": 372, "code": "ie", "text": "Ireland" },
  { "id": 833, "code": "im", "text": "Isle of Man" },
  { "id": 376, "code": "il", "text": "Israel" },
  { "id": 380, "code": "it", "text": "Italy" },
  { "id": 388, "code": "jm", "text": "Jamaica" },
  { "id": 392, "code": "jp", "text": "Japan" },
  { "id": 832, "code": "je", "text": "Jersey" },
  { "id": 400, "code": "jo", "text": "Jordan" },
  { "id": 398, "code": "kz", "text": "Kazakhstan" },
  { "id": 404, "code": "ke", "text": "Kenya" },
  { "id": 296, "code": "ki", "text": "Kiribati" },
  { "id": 408, "code": "kp", "text": "Korea, Democratic People's Republic of" },
  { "id": 410, "code": "kr", "text": "Korea, Republic of" },
  { "id": 414, "code": "kw", "text": "Kuwait" },
  { "id": 417, "code": "kg", "text": "Kyrgyzstan" },
  { "id": 418, "code": "la", "text": "Lao People's Democratic Republic" },
  { "id": 428, "code": "lv", "text": "Latvia" },
  { "id": 422, "code": "lb", "text": "Lebanon" },
  { "id": 426, "code": "ls", "text": "Lesotho" },
  { "id": 430, "code": "lr", "text": "Liberia" },
  { "id": 434, "code": "ly", "text": "Libya" },
  { "id": 438, "code": "li", "text": "Liechtenstein" },
  { "id": 440, "code": "lt", "text": "Lithuania" },
  { "id": 442, "code": "lu", "text": "Luxembourg" },
  { "id": 446, "code": "mo", "text": "Macao" },
  { "id": 807, "code": "mk", "text": "Macedonia, the former Yugoslav Republic of" },
  { "id": 450, "code": "mg", "text": "Madagascar" },
  { "id": 454, "code": "mw", "text": "Malawi" },
  { "id": 458, "code": "my", "text": "Malaysia" },
  { "id": 462, "code": "mv", "text": "Maldives" },
  { "id": 466, "code": "ml", "text": "Mali" },
  { "id": 470, "code": "mt", "text": "Malta" },
  { "id": 584, "code": "mh", "text": "Marshall Islands" },
  { "id": 474, "code": "mq", "text": "Martinique" },
  { "id": 478, "code": "mr", "text": "Mauritania" },
  { "id": 480, "code": "mu", "text": "Mauritius" },
  { "id": 175, "code": "yt", "text": "Mayotte" },
  { "id": 484, "code": "mx", "text": "Mexico" },
  { "id": 583, "code": "fm", "text": "Micronesia, Federated States of" },
  { "id": 498, "code": "md", "text": "Moldova" },
  { "id": 492, "code": "mc", "text": "Monaco" },
  { "id": 496, "code": "mn", "text": "Mongolia" },
  { "id": 499, "code": "me", "text": "Montenegro" },
  { "id": 500, "code": "ms", "text": "Montserrat" },
  { "id": 504, "code": "ma", "text": "Morocco" },
  { "id": 508, "code": "mz", "text": "Mozambique" },
  { "id": 104, "code": "mm", "text": "Myanmar" },
  { "id": 516, "code": "na", "text": "Namibia" },
  { "id": 520, "code": "nr", "text": "Nauru" },
  { "id": 524, "code": "np", "text": "Nepal" },
  { "id": 528, "code": "nl", "text": "Netherlands" },
  { "id": 530, "code": "an", "text": "Netherlands Antilles" },
  { "id": 540, "code": "nc", "text": "New Caledonia" },
  { "id": 554, "code": "nz", "text": "New Zealand" },
  { "id": 558, "code": "ni", "text": "Nicaragua" },
  { "id": 562, "code": "ne", "text": "Niger" },
  { "id": 566, "code": "ng", "text": "Nigeria" },
  { "id": 570, "code": "nu", "text": "Niue" },
  { "id": 901, "code": "ap", "text": "Non-spec Asia Pas Location" },
  { "id": 574, "code": "nf", "text": "Norfolk Island" },
  { "id": 580, "code": "mp", "text": "Northern Mariana Islands" },
  { "id": 578, "code": "no", "text": "Norway" },
  { "id": 512, "code": "om", "text": "Oman" },
  { "id": 586, "code": "pk", "text": "Pakistan" },
  { "id": 585, "code": "pw", "text": "Palau" },
  { "id": 275, "code": "ps", "text": "Palestine" },
  { "id": 591, "code": "pa", "text": "Panama" },
  { "id": 598, "code": "pg", "text": "Papua New Guinea" },
  { "id": 600, "code": "py", "text": "Paraguay" },
  { "id": 604, "code": "pe", "text": "Peru" },
  { "id": 608, "code": "ph", "text": "Philippines" },
  { "id": 612, "code": "pn", "text": "Pitcairn" },
  { "id": 616, "code": "pl", "text": "Poland" },
  { "id": 620, "code": "pt", "text": "Portugal" },
  { "id": 630, "code": "pr", "text": "Puerto Rico" },
  { "id": 634, "code": "qa", "text": "Qatar" },
  { "id": 638, "code": "re", "text": "Réunion" },
  { "id": 642, "code": "ro", "text": "Romania" },
  { "id": 643, "code": "ru", "text": "Russia" },
  { "id": 646, "code": "rw", "text": "Rwanda" },
  { "id": 652, "code": "bl", "text": "Saint Barthélemy" },
  { "id": 654, "code": "sh", "text": "Saint Helena, Ascension and Tristan da Cunha" },
  { "id": 659, "code": "kn", "text": "Saint Kitts and Nevis" },
  { "id": 662, "code": "lc", "text": "Saint Lucia" },
  { "id": 663, "code": "mf", "text": "Saint Martin (French part)" },
  { "id": 666, "code": "pm", "text": "Saint Pierre and Miquelon" },
  { "id": 670, "code": "vc", "text": "Saint Vincent and the Grenadines" },
  { "id": 882, "code": "ws", "text": "Samoa" },
  { "id": 674, "code": "sm", "text": "San Marino" },
  { "id": 678, "code": "st", "text": "Sao Tome and Principe" },
  { "id": 682, "code": "sa", "text": "Saudi Arabia" },
  { "id": 686, "code": "sn", "text": "Senegal" },
  { "id": 688, "code": "rs", "text": "Serbia" },
  { "id": 891, "code": "cs", "text": "SERBIA AND MONTENEGRO" },
  { "id": 690, "code": "sc", "text": "Seychelles" },
  { "id": 694, "code": "sl", "text": "Sierra Leone" },
  { "id": 702, "code": "sg", "text": "Singapore" },
  { "id": 534, "code": "sx", "text": "Sint Maarten (Dutch part)" },
  { "id": 703, "code": "sk", "text": "Slovakia" },
  { "id": 705, "code": "si", "text": "Slovenia" },
  { "id": 90, "code": "sb", "text": "Solomon Islands" },
  { "id": 706, "code": "so", "text": "Somalia" },
  { "id": 710, "code": "za", "text": "South Africa" },
  { "id": 239, "code": "gs", "text": "South Georgia and the South Sandwich Islands" },
  { "id": 728, "code": "ss", "text": "South Sudan" },
  { "id": 724, "code": "es", "text": "Spain" },
  { "id": 144, "code": "lk", "text": "Sri Lanka" },
  { "id": 736, "code": "sd", "text": "Sudan" },
  { "id": 740, "code": "sr", "text": "Suriname" },
  { "id": 744, "code": "sj", "text": "Svalbard and Jan Mayen" },
  { "id": 748, "code": "sz", "text": "Swaziland" },
  { "id": 752, "code": "se", "text": "Sweden" },
  { "id": 756, "code": "ch", "text": "Switzerland" },
  { "id": 760, "code": "sy", "text": "Syrian Arab Republic" },
  { "id": 158, "code": "tw", "text": "Taiwan" },
  { "id": 762, "code": "tj", "text": "Tajikistan" },
  { "id": 834, "code": "tz", "text": "Tanzania, United Republic of" },
  { "id": 764, "code": "th", "text": "Thailand" },
  { "id": 626, "code": "tl", "text": "Timor-Leste" },
  { "id": 768, "code": "tg", "text": "Togo" },
  { "id": 772, "code": "tk", "text": "Tokelau" },
  { "id": 776, "code": "to", "text": "Tonga" },
  { "id": 780, "code": "tt", "text": "Trinidad and Tobago" },
  { "id": 788, "code": "tn", "text": "Tunisia" },
  { "id": 792, "code": "tr", "text": "Turkey" },
  { "id": 795, "code": "tm", "text": "Turkmenistan" },
  { "id": 796, "code": "tc", "text": "Turks and Caicos Islands" },
  { "id": 798, "code": "tv", "text": "Tuvalu" },
  { "id": 800, "code": "ug", "text": "Uganda" },
  { "id": 804, "code": "ua", "text": "Ukraine" },
  { "id": 784, "code": "ae", "text": "United Arab Emirates" },
  { "id": 826, "code": "gb", "text": "United Kingdom" },
  { "id": 840, "code": "us", "text": "United States" },
  { "id": 581, "code": "um", "text": "United States Minor Outlying Islands" },
  { "id": 858, "code": "uy", "text": "Uruguay" },
  { "id": 860, "code": "uz", "text": "Uzbekistan" },
  { "id": 548, "code": "vu", "text": "Vanuatu" },
  { "id": 862, "code": "ve", "text": "Venezuela" },
  { "id": 704, "code": "vn", "text": "Vietnam" },
  { "id": 92, "code": "vg", "text": "Virgin Islands, British" },
  { "id": 850, "code": "vi", "text": "Virgin Islands, U.S." },
  { "id": 876, "code": "wf", "text": "Wallis and Futuna" },
  { "id": 732, "code": "eh", "text": "Western Sahara" },
  { "id": 887, "code": "ye", "text": "Yemen" },
  { "id": 894, "code": "zm", "text": "Zambia" },
  { "id": 716, "code": "zw", "text": "Zimbabwe" }
]
